import * as React from 'react';
import {
  Experimental_CssVarsProvider as CssVarsProvider,
  experimental_extendTheme as extendTheme,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import getLPTheme from './getLPTheme';

const theme = extendTheme({
  colorSchemes: {
    light: getLPTheme('light'),
    dark: getLPTheme('dark'),
  },
});

export default function AppTheme({ children }) {
  return (
    <CssVarsProvider theme={theme} defaultMode="light">
      <CssBaseline enableColorScheme />
      {children}
    </CssVarsProvider>
  );
}